import { render, staticRenderFns } from "./GoogleLogo.vue?vue&type=template&id=0375e0d5&"
import script from "./GoogleLogo.vue?vue&type=script&lang=ts&"
export * from "./GoogleLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports